/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { ReactComponent as Logo } from '../assets/logo.svg';
import noImage from '../assets/no-image.jpg';
import AppBar from '@mui/material/AppBar';
import Grid2 from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import DensitySmallIcon from '@mui/icons-material/DensitySmall'
import { getProduct, postClick, postOrder } from './api/konnective';
import FilledInput from '../components/FilledInput'; 
import Dropdown from '../components/Dropdown';
import BillingCheckbox from '../components/BillingCheckbox';
import AddressInput from '../components/AddressInput';
import { useUrlQuery } from '../lib/get-url-params';
import { Order, PageType } from '../types/api';
import Skeleton from '@mui/material/Skeleton';
import { ThankYouPage } from '../components/ThankYou';
import { InvalidRoutePage } from '../components/InvalidRoute';
import Alert from '@mui/material/Alert';

declare const EF: any;

const styles = {
  customizeToolbar: {
    minHeight: 75,
    backgroundColor: 'white',
    boxShadow: 'none',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'left'
  }
};

const isValidName = (value: string) => value.length >= 2 ? "" : 'Name must be at least 2 characters';
const isValidEmail = (value: string) => /\S+@\S+\.\S+/.test(value) ? "" : 'Invalid email address';
const isValidCity = (value: string) => value.trim().length > 0 ? "" : 'City cannot be empty';
const isValidPhone = (value: string) => /^\d{10}$/.test(value) ? "" : 'Phone number must be 10 digits';
const isValidZip = (value: string) => /^\d{5}(-\d{4})?$/.test(value) ? "" : 'Invalid zip/postal code';
const isValidCreditCard = (value: string) => /^(?:0{16})|(?:4\d{12}(?:\d{3})?|5[1-5]\d{14}|3[47]\d{13}|3(?:0[0-5]|[68]\d)\d{11}|6(?:011|5\d{2})\d{12}|(?:2131|1800|35\d{3})\d{11})$/.test(value.replace(/\s/g, '')) ? "" : 'Invalid credit card number';
const isValidExpirationDate = (value: string) => /^(0[1-9]|1[0-2])\/\d{2}$/.test(value) ? "" : 'Invalid expiration date (MM/YY)';
const isValidCVV = (value: string) => /^\d{3,4}$/.test(value) ? "" : 'Invalid CVV';
const isValidAddress = (value: string) => value.trim().length >= 5 ? "" : 'Address must be at least 5 characters';


function App() {
  const theme = useTheme();
  //screen size
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  //non store checks
  const [isThankYouPage, setIsThankYouPage] = React.useState(false);
  const [isInvalidRoutePage, setIsInvalidRoutePage] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  //store state
  const [product, setProduct] = useState();
  const [order, setOrder] = useState<any>({});
  const [everflowTrackerId, setEverflowTrackerId] = useState('');

  //url params
  const productId = useUrlQuery().get('productId');
  //direct access
  const affId = useUrlQuery().get('affId');
  //traditional access
  let sessionId = useRef(useUrlQuery().get('sessionId'));
  const base64UpsellUrl = useUrlQuery().get('upsellUrl');
  const upsellUrls = Buffer.from(base64UpsellUrl ?? '', 'base64');

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://www.wbhjf8trk.com/scripts/sdk/everflow.js";
    script.defer = true;
    script.onload = function () {
      if(EF !== undefined && EF !== null) {
        EF.click({
          offer_id: EF.urlParameter("oid"),
          affiliate_id: EF.urlParameter("affid"),
          sub1: EF.urlParameter("sub1"),
          sub2: EF.urlParameter("sub2"),
          sub3: EF.urlParameter("sub3"),
          sub4: EF.urlParameter("sub4"),
          sub5: EF.urlParameter("sub5"),
          uid: EF.urlParameter("uid"),
          source_id: EF.urlParameter("source_id"),
          transaction_id: EF.urlParameter("_ef_transaction_id"),
        }).then((transactionId: any) => {
          setEverflowTrackerId(transactionId);
        });
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    (async () => {
     if (!!productId) {
        if(sessionId){
          await postClick({
            pageType: PageType.checkoutPage,
            sessionId: sessionId.current ?? undefined,
          })
        }
        else if(affId && everflowTrackerId){
          const affiliateTrackingString = `/?affId=${affId}&c1=${everflowTrackerId}`;
          await postClick({
            pageType: PageType.checkoutPage,
            campaignId: undefined,
            requestUri: `${window.location.origin}${window.location.pathname}${affiliateTrackingString}`,
          })
        }
        else{
          setIsInvalidRoutePage(true);
          return;
        }
        const productResponse = await getProduct(productId);
        if(productResponse?.result === 'SUCCESS'){
          setProduct(productResponse?.message.data[0]);
        }
        else if(productResponse?.result === 'ERROR'){
          setError(productResponse?.message);
        }
      } else {
          console.warn('Product ID is null or undefined');
      }
    })();
  }, []);

  return (
    <div className="App">
      <AppBar position="static" sx={styles.customizeToolbar}>
        <Logo width='75' height='75'/>
      </AppBar>
      {error && <Alert variant="outlined" severity="error" onClose={() => setError(null)}>{error}</Alert>}
      {
        isInvalidRoutePage ? <InvalidRoutePage/> :
          isThankYouPage ? <ThankYouPage/> : 
            isMobileOrTablet ? 
              MobileCheckout({setIsThankYouPage, product, order, setOrder, setError, error}) : DesktopCheckout({setIsThankYouPage, product, order, setOrder, setError, error})
      }
    </div>
  );
}

function MobileCheckout({setIsThankYouPage, product, order, setOrder, setError, error}: any) {
  return (
    <>
      <AppBar position='sticky' className='summary-header' sx={{ color: 'black', boxShadow: 'none', background: '#f5f5f5'  }}>
        <Accordion sx={{ boxShadow: 'none', background: '#f5f5f5'}}>
          <AccordionSummary expandIcon={<DensitySmallIcon />}> 
            <div className='summary-header'>Order Summary</div>
          </AccordionSummary>
          <AccordionDetails sx={{ borderBottom: '1px solid #e0e0e0' }}>
            <OrderSummary product={product}/>
          </AccordionDetails>
        </Accordion>
      </AppBar>
      <Box className="container" sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', placeSelf: 'end'}}>
        <StoreForm setIsThankYouPage={setIsThankYouPage} product={product} order={order} setOrder={setOrder} setError={setError} error={error}/>
      </Box>
    </>
  );
}

function DesktopCheckout({setIsThankYouPage, product, order, setOrder, setError, error}: any) {
  return (
    <>
      <Grid2 container columns={16}>
        <Grid2 size={8} sx={{backgroundColor: 'white'}}>
          <Box className="container" sx={{paddingTop: '20px'}}>
            <StoreForm setIsThankYouPage={setIsThankYouPage} product={product} order={order} setOrder={setOrder} setError={setError} error={error}/>
          </Box>
        </Grid2>
        <Grid2 size={8}>
          <Box className="summary-container">
            <AppBar position='sticky' className='summary-header' sx={{ color: 'black', boxShadow: 'none', background: '#f5f5f5' }}>
              <OrderSummary product={product}/>
            </AppBar>
          </Box>
        </Grid2>
      </Grid2>
    </>
  );
}

function StoreForm({setIsThankYouPage, product, order, setOrder, setError, error}: any) {
  const [isChecked, setIsChecked] = useState<boolean>(true);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      handleInputChange(event);
      setIsChecked(event.target.checked);
  };

  const handleInputChange = (e: any) => {
    const { id, value } = e.target;
    setOrder((prevState: any) => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleFormSubmission = (e: any) => {
    e.preventDefault();

    const requiredFields = [
      "firstName",
      "lastName",
      "emailAddress",
      "address1",
      "city",
      "state",
      "country",
      "postalCode",
      "cardNumber",
      "cardSecurityCode",
      "expirationDate"
    ];

    const missingFields = requiredFields.filter((field) => !order[field]);

    if (missingFields.length > 0) {
      missingFields.forEach((field) => {
        setError((prevError: any) => `${prevError ? prevError + ", " : ""}${field} is required`);
      });
      return;
    }

    const mappedOrder: Order = {
      firstName: order.firstName,
      lastName: order.lastName,
      emailAddress: order.emailAddress,
      address1: order.address1,
      address2: order.address2 ?? "",
      city: order.city,
      state: order.state,
      country: order.country,
      postalCode: order.postalCode,
      phoneNumber: order.phoneNumber ?? "",
      cardNumber: order.cardNumber?.split(' ').join(''),
      cardSecurityCode: order.cardSecurityCode,
      cardMonth: order.expirationDate?.split('/')[0],
      cardYear: order.expirationDate?.split('/')[1],
      paySource: 'CREDITCARD',
      campaignId: `${product?.campaignId}`,
      product1_id: `${product?.productId}`,
      product1_qty: `${product?.productQty}`
    };

    if (!isChecked) {
      mappedOrder.altFirstName = order.altFirstName;
      mappedOrder.altLastName = order.altLastName;
      mappedOrder.altAddress1 = order.altAddress1;
      mappedOrder.altAddress2 = order.altAddress2;
      mappedOrder.altCity = order.altCity;
      mappedOrder.altState = order.altState;
      mappedOrder.altCountry = order.altCountry;
      mappedOrder.altPostalCode = order.altPostalCode;
    }

    try {
      postOrder(mappedOrder).then((d) => {
        if (d?.result === 'SUCCESS') {
          setIsThankYouPage(true);
        } else if (d?.result === 'ERROR') {
          setError(d?.message);
        }
      });
    } catch (e) {
      console.error("Error submitting order:", e);
      setError("An error occurred while submitting the order. Please try again.");
    }
  };


  return (
    <>
      <form id="checkout-form" onSubmit={handleFormSubmission}>
        <h3>Contact</h3>
        <div className="form-row">
          <FilledInput id="emailAddress" label="Email" placeholder="Enter your email" validate={isValidEmail} inputChange={handleInputChange}/>
        </div>

        <h3>Delivery</h3>
        {BillingInfo(false, {order, handleInputChange, setError})}
        <h3>Payment</h3>
        <em>All transactions are secure and encrypted.</em>
        <div className="payment-container">
            <div className="form-row">
              <span>Credit card</span>
              <div>
                <img alt="VISA"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/visa.sxIq5Dot.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
                <img alt="MASTERCARD"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/mastercard.1c4_lyMp.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
                <img alt="AMEX"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/amex.Csr7hRoy.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
                <img alt="DISCOVER"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/discover.C7UbFpNb.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
              </div>      
            </div>
            <div className="form-row">
              <FilledInput id="cardNumber" label="Card Number" placeholder="Enter card number" validate={isValidCreditCard} tooltip=' ' inputChange={handleInputChange}/>
            </div>
            <div className="form-row">
              <FilledInput id="expirationDate" label="Expiration date (MM / YY)" placeholder="MM/YY" validate={isValidExpirationDate} inputChange={handleInputChange}/>
              <FilledInput id="cardSecurityCode" label="Security code" placeholder="Security code" validate={isValidCVV} tooltip="3-digit security Code usually found on the back of your card. American Express cards have a 4-digit code located on the form." inputChange={handleInputChange}/>
            </div>
            <div className="form-row">
              <FilledInput id="" label="Name on Card" placeholder="Name on Card" validate={isValidName} inputChange={handleInputChange}/>
            </div>
            <div className="form-norow">
                <BillingCheckbox isChecked={isChecked} onChange={handleCheckboxChange}/>
            </div>
                {!isChecked && BillingInfo(true, {order, handleInputChange, setError})}
        </div>

        <br />
        <em>Secure and encrypted</em>
        <button type="submit" className="pay-button" disabled={!!error}>Pay Now</button>

        <em>Your info will be saved to a Konnektive CRM account. By continuing, you agree to Konnektive's Terms of Service and
            acknowledge the Privacy Policy.</em>
        <hr />
        <em>
            <div>
                <a target="_blank" rel="noopener noreferrer" href="https://konnektive.com/billing-policy.html">Refund policy</a>
                <a target="_blank" rel="noopener noreferrer" href="https://konnektive.com/eula.html">Privacy policy</a>
                <a target="_blank" rel="noopener noreferrer" href="https://konnektive.com/billing-policy.html">Terms of service</a>
            </div>
            <div>
                By placing this order, you agree to our Terms of Service and understand our Privacy Policy.
            </div>
        </em>
      </form>   
    </>
  )
}

function OrderSummary({product}: any) {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  return (
      product ? 
        (
          <>
            {isMobileOrTablet ? null : <div className="summary-header">Order Summary</div>}
            <div className="summary-item">
              <img alt="product image" src={product.productImagePath ??  noImage} /><i>${product.msrp ?? ''}</i>
              <strong>{product.productName?.split('|')[0] ?? ''}</strong>
              <em>{product.productQty ?? ''} bottle{product.productQty > 1 ? 's' : ''}</em>
              <div className="clear"></div>
              </div>
              
              <div className="summary-item">
              <strong>Subtotal</strong>
              <i>${product.msrp ?? ''}</i>
              <div className="clear"></div>
              </div>
              <div className="summary-item">
              <strong>Shipping</strong>
              <i>${product.shippingCost ?? '0.00'}</i>
              <div className="clear"></div>
              </div>
              <div className="summary-item">
              <strong>Estimated taxes</strong>
              <i>$0.00</i>
              <div className="clear"></div>
              </div>
              <div className="summary-item summary-total">
              <strong>Total</strong>
              <i><span className="currency">USD</span>${product.msrp ?? '0.00'}</i>
              <div className="clear"></div>
            </div>
          </>
        ) : (
        <>
            <div className="summary-header">
            <Skeleton variant="text" width={150} height={30} />
            </div>
            <div className="summary-item">
            <Skeleton variant="rectangular" width={50} height={50} />
            <i><Skeleton variant="text" width={100} /></i>
            <strong><Skeleton variant="text" width={120} /></strong>
            <em><Skeleton variant="text" width={80} /></em>
            <div className="clear"></div>
            </div>
            
            <div className="summary-item">
            <strong><Skeleton variant="text" width={80} /></strong>
            <i><Skeleton variant="text" width={50} /></i>
            <div className="clear"></div>
            </div>
            <div className="summary-item">
            <strong><Skeleton variant="text" width={80} /></strong>
            <i><Skeleton variant="text" width={50} /></i>
            <div className="clear"></div>
            </div>
            <div className="summary-item">
            <strong><Skeleton variant="text" width={120} /></strong>
            <i><Skeleton variant="text" width={50} /></i>
            <div className="clear"></div>
            </div>
            <div className="summary-item summary-total">
            <strong><Skeleton variant="text" width={80} /></strong>
            <i><Skeleton variant="text" width={100} /></i>
            <div className="clear"></div>
            </div>
        </>)
  )
}

function BillingInfo(alt: boolean, {order, handleInputChange, setError}: any) {
  const [addressFields, setAddressFields] = useState({
    city: '',
    state: '',
    postalCode: '',
    country: 'US'
  });

  useEffect(() => {
    if (order) {
      setAddressFields(prev => ({
        ...prev,
        city: alt ? order.altCity || '' : order.city || '',
        state: alt ? order.altState || '' : order.state || '',
        postalCode: alt ? order.altPostalCode || '' : order.postalCode || '',
        country: alt ? order.altCountry || 'US' : order.country || 'US'
      }));
    }
  }, [order, alt]);

  const handleAddressComponentsChange = (components: any) => {
    const stateMap: { [key: string]: string } = {
      'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California',
      'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'FL': 'Florida', 'GA': 'Georgia',
      'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa',
      'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
      'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri',
      'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey',
      'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio',
      'OK': 'Oklahoma', 'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
      'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont',
      'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming'
    };

    const fullStateName = stateMap[components.state] || components.state;
    components.state = fullStateName;
    setAddressFields({
      city: components.city,
      state: components.state,
      postalCode: components.postalCode,
      country: 'US' 
    });

    const fields = [
      { id: alt ? "altCity" : "city", value: components.city },
      { id: alt ? "altPostalCode" : "postalCode", value: components.postalCode },
      { id: alt ? "altCountry" : "country", value: 'US' },
      { id: alt ? "altState" : "state", value: components.state }
    ];

    fields.forEach(field => {
      const syntheticEvent = {
        target: {
          id: field.id,
          value: field.value
        }
      };
      handleInputChange(syntheticEvent);
    });
  };

  const handleFieldChange = (e: any) => {
    const { id, value } = e.target;
    const fieldName = id.replace(alt ? "alt" : "", "").toLowerCase();
    
    setAddressFields(prev => ({
      ...prev,
      [fieldName]: value
    }));

    handleInputChange(e);
  };

  return (
    <>
      <div className="form-row">
          <Dropdown 
            id={alt ? "altCountry" : "country"} 
            label="Country" 
            options={["US"]} 
            inputChange={handleFieldChange}
            value={addressFields.country}
          />
      </div>
      <div className="form-row">
        <FilledInput id={alt ? "altFirstName" : "firstName"} label="First Name" placeholder="Enter first name" validate={isValidName} inputChange={handleInputChange}/>
        <FilledInput id={alt ? "altLastName" : "lastName"} label="Last Name" placeholder="Enter last name" validate={isValidName} inputChange={handleInputChange}/>
      </div>
      <div className="form-row">
        <AddressInput 
          id={alt ? "altAddress1" : "address1"} 
          label="Address" 
          placeholder="Address" 
          validate={isValidAddress} 
          inputChange={handleInputChange}
          onAddressComponentsChange={handleAddressComponentsChange}
        />
      </div>
      <div className="form-row">
        <FilledInput id={alt ? "altAddress2" : "address2"} label="Apartment, suite, etc. (optional)" placeholder="Apartment, suite, etc. (optional)" validate={isValidCity} inputChange={handleInputChange}/>
      </div>
      <div className="form-row">
        <FilledInput 
          id={alt ? "altCity" : "city"} 
          label="City" 
          placeholder="Enter your city" 
          validate={isValidCity} 
          inputChange={handleFieldChange}
          value={addressFields.city}
        />
        <Dropdown 
          id={alt ? "altState" : "state"} 
          label="State"
          options={[
            "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", 
            "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", 
            "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", 
            "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", 
            "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", 
            "New Hampshire", "New Jersey", "New Mexico", "New York", 
            "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", 
            "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", 
            "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", 
            "West Virginia", "Wisconsin", "Wyoming"
          ]}
          inputChange={handleFieldChange}
          value={addressFields.state}
        />
        <FilledInput 
          id={alt ? "altPostalCode" : "postalCode"} 
          label="Zip" 
          placeholder="Enter zip code" 
          validate={isValidZip} 
          inputChange={handleFieldChange}
          value={addressFields.postalCode}
        />
      </div>
      <div className="form-row">
        <FilledInput id={alt ? "phoneNumber" : ""} label="Phone (Optional)" placeholder="Enter phone number" validate={isValidPhone} tooltip="In case we need to contact you about your order" inputChange={handleInputChange}/>
      </div>
    </>
  );
}

export default App;